import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';
// Hooks
import useUser from '@/utils/hooks/swr/useUser';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import { FREE_PLAN } from '@/types/pricingTypes/planType';

// Lib
import { planCards } from '@/lib/pricing/planCards';

import H2 from '@/components/base/Headings/H2';
// Components
import Icon from '@/components/base/Icon';
import { PlanPrice } from '@/components/pages/settings/subscription-invoices/CurrentUserPlan/PlanPrice';

export function CurrentUserPlan() {
    const { user } = useUser();
    const { subscription } = useSubscription();
    const { t } = useTranslation();

    const icon = planCards?.[subscription.product_key]?.icon;
    const nbUsers = subscription.options.users?.count_total ?? '∞';
    const nbProfiles = subscription.options.profiles?.count_total ?? '∞';
    const nbGroups = user?.quotas?.groups?.purchased ?? '∞';

    return (
        <div data-testid="current-plan-layout">
            <div className="relative overflow-hidden rounded-xl border border-icoGray-300 bg-icoGray-100 p-8 dark:border-icoDarkMode-beton dark:bg-icoDarkMode-anthracite">
                <div className="relative z-1 space-y-3 text-sm">
                    <H2 className="flex items-center gap-2">
                        {t(
                            `commons:pricing.plans.${subscription.product_key}`,
                            {},
                            { fallback: `commons:subscriptions.${subscription.product_title}` }
                        )}
                        {icon ? <Icon icon={icon} className="text-icoBlue" /> : null}
                    </H2>
                    <PlanPrice />
                    <div className="space-y-2">
                        <p>
                            <span className="font-GBold leading-none">{nbProfiles}</span>{' '}
                            {t('commons:subscriptions.nb_profiles')}
                        </p>
                        <p>
                            <span className="font-GBold leading-none">{nbUsers}</span>{' '}
                            {t('commons:subscriptions.nb_users')}
                        </p>
                        {nbGroups !== 0 ? (
                            <p>
                                <span className="font-GBold leading-none">{nbGroups}</span>{' '}
                                {t('commons:subscriptions.nb_groups')}
                            </p>
                        ) : null}
                        {subscription.product_key === FREE_PLAN ? (
                            <p>
                                <span className="font-GBold leading-none">10</span>{' '}
                                {t('commons:subscriptions.free_plan_posts_limit')}
                            </p>
                        ) : null}
                    </div>
                </div>
                <div className="absolute left-0 top-0 h-full w-full bg-icoRecapPlanSubscription" />
            </div>
        </div>
    );
}
